import _ from 'underscore';
import { useCallback } from 'react';

function isShiproomErrorMessage(message) {
  if (message.includes('NO_RECOMMENDATION') || message.includes('UrlNotAccessible')) {
    return false;
  }

  return true;
}

export function useLogRecommendationsApiError(activity) {
  const log = useCallback((error) => {
    const message = `Recommendations API error: ${error instanceof Error ? error : JSON.stringify(error)}`;
    const isShiproomError = isShiproomErrorMessage(message);

    const requestId = _.get(error, ['headers', 'x-ms-requestid']) || _.get(error, 'requestId');

    let logFn;
    if (activity) {
      logFn = (m) => {
        const f = isShiproomError ? activity.error : activity.trace;
        return f(m, undefined, requestId);
      };
    } else {
      // eslint-disable-next-line no-console
      logFn = isShiproomError ? console.error : console.log;
    }

    logFn(message);
  }, [activity]);

  return log;
}
